import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
// import { ExceptionTypeEnum } from '@ordersnproducts/modules/shared/models/exception-type.enum';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: Error | HttpErrorResponse) {
    // appInsights.trackException(error);
    // appInsights.trackTrace(ExceptionTypeEnum.JS, { name: error.name, message: error.message });
    console.error(error);
  }
}
